export default {
  nav: {
    onlineSms: 'SMS en ligne',
    rentNumber: 'Dév. logiciel',
    esim: 'Loterie',
    apiConnection: 'API',
    agent: 'Chat en direct',
    blog: 'Partage',
    help: 'Aide',
    register: "S'inscrire",
    login: 'Connexion'
  },
  header: {
    memberCenter: 'Espace membre',
    logout: 'Déconnexion',
    logoutSuccess: 'Déconnexion réussie'
  },
  common: {
    user: 'Utilisateur',
    chinese: 'Chinois',
    loading: 'Chargement...',
    noData: 'Aucune donnée',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    back: 'Retour',
    submit: 'Soumettre',
    search: 'Rechercher',
    success: 'Succès',
    error: 'Erreur',
    warning: 'Avertissement',
    info: 'Info',
    copySuccess: 'Copié avec succès',
    copyFailed: 'Échec de la copie',
    operationSuccess: 'Opération réussie',
    operationFailed: 'Opération échouée',
    networkError: 'Erreur réseau, veuillez réessayer plus tard',
    payWith: 'Payer avec',
    unit: '',
    yes: 'Oui',
    no: 'Non',
    all: 'Tout',
    more: 'Plus',
    next: 'Suivant',
    prev: 'Précédent'
  },
  home: {
    title: 'Plateforme de réception SMS',
    subtitle: 'Inscrivez-vous sur les réseaux sociaux, boutiques en ligne, plateformes d\'échange et services en ligne sans recevoir de spam ni exposer vos données personnelles.',
    btnGetNumber: 'Obtenir un numéro',
    btnRent: 'Louer',
    phoneCount: '1000+',
    sectionTitle: 'SMS-MAN — Louez des numéros de téléphone pour recevoir des SMS',
    sectionDesc: 'Avec SMS-MAN, vous pouvez louer un numéro virtuel pour recevoir des SMS de plus de 200 pays. Durée de location : 24 heures, une semaine ou un mois.',
    sectionDesc2: 'C\'est très pratique lorsque vous devez enregistrer de nombreuses applications en ligne avec un numéro de téléphone spécifié. Si le numéro ne vous convient pas, vous pouvez l\'annuler gratuitement dans les 20 minutes !',
    howItWorks: 'Voir comment ça marche',
    stepsTitle: 'Louez un numéro virtuel en ligne en 3 étapes',
    step1Title: 'Choisissez votre pays',
    step2Title: 'Définissez la durée',
    step3Title: 'Louez un numéro',
    step1Desc: 'Inde, Mexique, Israël',
    step2Desc: 'Heure, Jour, Semaine, Mois',
    step3Desc: 'Durée de location',
    whyChoose: 'Pourquoi choisir SMS-MAN',
    feature1Title: 'Vous pouvez acheter un numéro ponctuel ou louer un numéro jusqu\'à un mois',
    feature2Title: 'Numéro ponctuel pour recevoir des SMS',
    feature2Desc: 'Sélectionnez un service ou tous les services pour recevoir des SMS via un numéro virtuel.',
    feature3Title: 'Louer un numéro',
    feature3Desc: 'Louez un numéro de téléphone et recevez des SMS illimités de n\'importe quel site ou application.',
    usageLimit: 'Limite d\'utilisation',
    usageLimitDesc: 'Jusqu\'à 20 minutes',
    usageLimitDesc2: 'Jusqu\'à 30 jours',
    youCanReceive: 'Vous pouvez recevoir des SMS',
    youCanReceiveDesc: 'D\'un site/application sélectionné',
    youCanReceiveDesc2: 'Tous les services disponibles',
    serviceCount: '200+',
    serviceCount2: '16',
    countryCount: '1000+',
    countryCount2: 'Tous les services disponibles',
    btnRentNow: 'Louer maintenant',
    btnRentNumber: 'Louer un numéro',
    aboutText: '"SMS-Man" vous permet de créer un numéro virtuel pour recevoir des SMS.',
    aboutText2: 'De nombreux sites nécessitent une vérification SMS. Ces services ne sont généralement pas disponibles avec des numéros étrangers.',
    aboutText3: 'SMS-MAN fournit des services dans plus de 200 pays/régions.',
    aboutText4: 'Il y a de nombreux avantages à louer des numéros sur "SMS-Man" :',
    aboutText5: 'Un numéro virtuel peut être utilisé pour s\'inscrire sur plus de 200 sites et applications.',
    aboutText6: 'Vous n\'avez pas à vous soucier d\'exposer votre numéro personnel.',
    aboutText7: 'Gérez les numéros de différents pays et recevez des SMS sur une seule plateforme.',
    aboutText8: 'Vous n\'avez pas besoin de compétences professionnelles et le prix est très bon marché.',
    aboutText9: 'Vous pouvez louer un numéro en ligne à tout moment !',
    registerTitle: 'S\'inscrire',
    registerDesc: 'Pas besoin de saisir vos informations personnelles, juste 3 étapes',
    regStep1: 'Entrez votre email sur le site',
    regStep1Desc: 'Entrez votre adresse email et créez un mot de passe.',
    regStep2: 'Confirmez votre email',
    regStep2Desc: 'Nous avons envoyé un email de confirmation. Ouvrez-le et cliquez sur le lien.',
    regStep3: 'Félicitations ! Vous êtes inscrit',
    regStep3Desc: 'Vous pouvez maintenant vous connecter et utiliser tous les services SMS-MAN.',
    onlineServiceTitle: 'Service pratique de réception SMS en ligne',
    joinTelegram: 'Rejoignez notre chat en ligne',
    joinTelegramDesc: 'Rejoignez notre groupe Telegram pour les dernières nouvelles',
    telegramBot: 'Bot Telegram',
    telegramBotDesc: 'Utilisez le Bot Telegram pour recevoir des SMS',
    userGroup: 'Groupe d\'utilisateurs',
    userGroupDesc: 'Rejoignez le groupe pour obtenir de l\'aide',
    desktopApp: 'Application de bureau',
    desktopAppDesc: 'Téléchargez l\'application de bureau',
    btnJoin: 'Rejoindre',
    btnConnect: 'Connecter',
    btnDownload: 'Télécharger',
    professionalTitle: 'Solution pour les professionnels',
    professionalDesc: 'SMS-MAN fournit des outils pratiques pour les utilisateurs ordinaires et les professionnels.',
    apiConnect: 'Connexion via API',
    apiConnectDesc: 'Recevez et envoyez des SMS en lot, automatisez votre travail',
    readMore: 'En savoir plus',
    faqTitle: 'FAQ',
    faq1: 'Qu\'est-ce que le service de plateforme SMS ?',
    faq2: 'Qu\'est-ce que SMS-MAN ?',
    faq3: 'Ai-je besoin d\'une carte SIM ponctuelle ?',
    faq4: 'Les informations privées sont-elles en sécurité ?',
    faq5: 'Comment confirmer la réception du SMS ?',
    faq6: 'La plateforme SMS est-elle vraiment sûre ?',
    faq7: 'Pourquoi choisir SMS-Man ?',
    footer: {
      smsPlatform: 'Plateforme SMS',
      rentNumber: 'Louer un numéro',
      apiConnection: 'API',
      referral: 'Parrainage',
      partnership: 'Partenariat',
      partners: 'Partenaires',
      blog: 'Partage',
      help: 'Aide',
      privacyPolicy: 'Politique de confidentialité',
      termsOfUse: 'Conditions d\'utilisation',
      paymentRefund: 'Paiement et remboursement',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  login: {
    title: 'Connexion',
    email: 'Email',
    password: 'Mot de passe',
    emailPlaceholder: 'Entrez votre email',
    passwordPlaceholder: 'Entrez votre mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: 'Pas encore de compte ?',
    register: 'S\'inscrire',
    socialLogin: 'Ou connectez-vous avec votre plateforme sociale',
    btnLogin: 'Se connecter',
    captchaSuccess: 'Succès !',
    loginFailed: 'Échec de la connexion'
  },
  register: {
      title: 'S\'inscrire',
      email: 'Entrer l\'email',
      codePlaceholder: 'Entrer le code de vérification',
      sendCode: 'Obtenir le code',
      sending: 'Envoi en cours...',
      codeSent: 'Code envoyé, veuillez vérifier votre email',
      password: 'Créer un mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      agreeTerms: 'L\'inscription implique l\'acceptation des',
      terms: 'Conditions d\'utilisation',
      hasAccount: 'Vous avez déjà un compte?',
      login: 'Connexion',
      socialLogin: 'Ou connectez-vous avec votre compte social',
      btnRegister: 'S\'inscrire',
      registering: 'Inscription...',
      captchaSuccess: 'Succès!',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      registerFailed: 'Échec de l\'inscription',
      codeExpired: 'Code expiré, veuillez redemander',
      codeError: 'Code de vérification invalide'
    },
  member: {
    sidebar: {
      receiveSms: 'Recevoir SMS',
      premiumSms: 'SMS Premium',
      rentNumber: 'Louer un numéro',
      esim: 'eSIM',
      proxyMan: 'Proxy Man',
      recharge: 'Recharger',
      loyalty: 'Programme de fidélité',
      earn: 'Gagner',
      partnership: 'Partenariat',
      api: 'API',
      instructions: 'Instructions',
      feedback: 'Retour',
      help: 'Aide',
      chatGroup: 'Chat en direct',
      chatManage: 'Gestion du chat',
      receptionRecords: 'Historique d\'accueil',
      chatPlan: 'Forfait chat',
	  chatSettings: 'Paramètres du chat',
      lotteryGroup: 'Loterie',
      lotteryBets: 'Historique des paris'
    },
    header: {
      desktopClient: 'Client bureau',
      desktopClientDesc: 'Recevez des SMS directement sur votre ordinateur',
      telegramBot: 'Bot Telegram',
      telegramBotDesc: 'Recevez des SMS directement sur Telegram',
      try: 'Essayer',
      connect: 'Connecter',
      balance: 'Solde',
      recharge: 'Recharger',
      language: 'Langue'
    },
    avatarMenu: {
      settings: 'Paramètres',
      profile: 'Voir le profil',
      logout: 'Déconnexion'
    },
    receiveSms: {
      title: 'Recevoir SMS',
      selectService: 'Sélectionner un service',
      searchService: 'Rechercher par service',
      selectCountry: 'Sélectionner votre pays',
      searchCountry: 'Rechercher par pays',
      sort: 'Trier',
      buySms: 'Acheter SMS',
      doubleSms: 'Double SMS',
      btnBuySms: 'Acheter SMS'
    },
    premiumSms: {
      title: 'SMS Premium',
      selectService: 'Sélectionner un service',
      searchService: 'Rechercher par service',
      selectCountry: 'Sélectionner votre pays',
      searchCountry: 'Rechercher par pays',
      sort: 'Trier',
      buySms: 'Acheter SMS',
      doubleSms: 'Double SMS',
      btnBuySms: 'Acheter SMS'
    },
    rentNumber: {
      title: 'Louer un numéro',
      subtitle: 'Uniquement pour recevoir des SMS',
      wholeNumber: 'Numéro complet',
      byService: 'Par service',
      selectCountry: '1. Sélectionner le pays',
      search: 'Rechercher',
      setDuration: '2. Définir la durée',
      hour: 'Heure',
      day: 'Jour',
      week: 'Semaine',
      month: 'Mois',
      rentNumber: '3. Louer un numéro',
      cost: 'Coût',
      btnRent: 'Louer',
      rentDesc: 'Vous payez pour le numéro et sa durée de location. Pendant la période sélectionnée, vous pouvez recevoir des SMS illimités.',
      premiumTitle: 'Numéro Premium',
      premiumDesc: 'Accédez à des numéros de haute qualité avec des taux de livraison plus élevés',
      btnPremium: 'Obtenir Premium'
    },
    esim: {
      title: 'eSIM',
      selectCountry: '1. Sélectionner le pays / la région',
      searchCountry: 'Rechercher un pays ou une région',
      all: 'Tout',
      mixed: 'Mixte',
      showAll: 'Tout afficher',
      selectPlan: '2. Sélectionner un forfait',
      esimInfo: 'L\'eSIM est activée immédiatement après le paiement.',
      phoneSupport: 'Votre téléphone prend-il en charge l\'eSIM ?',
      phoneSupportDesc: 'Composez *#06#, si EID s\'affiche, l\'appareil prend en charge l\'eSIM.',
      howToConfig: 'Comment configurer les données mobiles via eSIM',
      selectType: '3. Sélectionner le type d\'eSIM',
      allType: 'Tout',
      dataOnly: 'Données uniquement',
      dataAndCall: 'Données + Appels',
      btnRecharge: 'Recharger'
    },
    recharge: {
      title: 'Recharger le solde',
      payMethod: 'Mode de paiement',
      usdtDesc: 'Rechargez via USDT TRC-20, crédité après confirmation admin',
      onlyUsdt: 'USDT uniquement',
      fillAmount: 'Montant de recharge',
      otherAmount: 'Montant personnalisé',
      btnPay: 'Recharger',
      submitting: 'Envoi...',
      payDesc: "L'adresse USDT et le QR code seront affichés après la création de la commande",
      invalidAmount: 'Veuillez entrer un montant valide (min $1)',
      rechargeFailed: 'Échec de la recharge',
      rechargeFailedRetry: 'Échec de la recharge, veuillez réessayer',
      historyTitle: 'Historique des recharges',
      thOrderNo: 'N° commande',
      thAmount: 'Montant',
      thStatus: 'Statut',
      thTime: 'Heure',
      statusPending: 'En attente',
      statusPaid: 'Crédité',
      statusCancelled: 'Annulé',
      scanToPay: 'Scanner pour payer',
      payAmount: 'Montant',
      usdtAddress: 'Adresse USDT TRC-20',
      copy: 'Copier',
      copied: 'Copié',
      orderNo: 'N° commande',
      waitingConfirm: "En attente de confirmation admin, rafraîchissement automatique après paiement",
      paySuccess: 'Recharge créditée',
      paySuccessDesc: 'Votre recharge a été créditée avec succès'
    },
    feedback: {
      title: 'Contactez-nous',
      name: 'Votre nom',
      email: 'Email',
      question: 'Votre question',
      btnSend: 'Envoyer',
      captchaSuccess: 'Succès !',
      support247: 'Support 24h/24 7j/7',
      responseTime: 'Temps de réponse moyen environ 15 minutes',
      weekendWork: 'Support week-end comme d\'habitude',
      chatSupport: 'Support chat',
      youtube: 'Notre YouTube'
    },
    partnership: {
      title: 'Gagnez de l\'argent avec des cartes SIM',
      desc1: 'Si vous avez des numéros de téléphone pouvant recevoir des SMS, cette page est pour vous.',
      desc2: 'Commencez à gagner avec SMS-Man !',
      whatTogether: 'Que pouvons-nous faire ensemble ?',
      whatTogetherDesc: 'SMS-Man est une plateforme internationale de réception SMS en ligne.',
      whatTogetherDesc2: 'Nos clients sont de plus en plus nombreux. C\'est pourquoi nous vous cherchons.',
      howContact: 'Comment contacter SMS-Man ?',
      restApi: 'REST API',
      restApiDesc: 'Vous nous fournissez des fichiers API et un compte de paiement.',
      gsmGoip: 'GSM/GoIP',
      gsmGoipDesc1: 'Vous avez un équipement GSM/GoIP',
      gsmGoipDesc2: 'Nous utilisons un logiciel spécial pour vous connecter',
      gsmGoipDesc3: 'Vous pourrez suivre les statistiques',
      gsmGoipDesc4: 'Le revenu dépend du pays de la carte SIM',
      apiLink: 'Lien API',
      apiLinkDesc1: 'Par exemple, vous avez des numéros dans ce format :',
      apiLinkDesc2: 'Nous achetons des numéros selon les conditions'
    },
    instructions: {
      title: 'Inscription Facebook via SMS-MAN',
      step1: 'Étape 1. Obtenez un numéro.',
      step1Desc: 'Pour cela, utilisez un numéro ponctuel',
      receiveSms: 'Recevoir SMS',
      or: 'ou',
      rentNumber: 'Louer un numéro',
      step2: 'Étape 2 : Copiez le numéro.',
      step2Desc: 'Cliquez sur l\'icône ou sélectionnez le numéro, appuyez sur Ctrl+C.',
      step3: 'Étape 3. Remplissez les informations Facebook.',
      step3Desc: 'Allez sur facebook.com, cliquez sur "Créer un compte".'
    },
    loyalty: { title: 'Programme de fidélité' },
    earn: { title: 'Gagner' },
    api: { title: 'Documentation API' },
    help: { title: 'Centre d\'aide' },
    lotteryBets: {
      title: 'Historique des paris',
      allTypes: 'Tous les types',
      allResults: 'Tous les résultats',
      win: 'Gain',
      lose: 'Perte',
      pending: 'En attente',
      searchPeriod: 'Rechercher une période...',
      totalBets: 'Total des paris',
      totalWin: 'Gain',
      totalLose: 'Perte',
      totalPending: 'En attente',
      totalProfit: 'P/L total',
      period: 'Période',
      lotteryType: 'Type',
      playType: 'Jeu',
      betContent: 'Contenu du pari',
      betAmount: 'Montant',
      odds: 'Cotes',
      drawNumbers: 'Numéros tirés',
      result: 'Résultat',
      profit: 'P/L',
      time: 'Heure',
      totalRecords: '{0} enregistrements',
      prevPage: 'Précédent',
      nextPage: 'Suivant'
    },
    profile: {
      title: 'Profil',
      pageDesc: 'Voir les détails de votre compte',
      userId: 'ID utilisateur',
      balance: 'Solde',
      registerTime: 'Date d\'inscription',
      lastLogin: 'Dernière connexion',
      accountStatus: 'Statut du compte',
      langSetting: 'Langue',
      statusActive: 'Actif',
      statusInactive: 'Désactivé',
      apiInfo: 'Info API',
      apiKey: 'Clé API',
      notGenerated: 'Non générée',
      copy: 'Copier',
      usageStats: 'Statistiques d\'utilisation',
      smsOrders: 'Commandes SMS',
      rechargeCount: 'Recharges',
      totalSpent: 'Total dépensé',
      chatSessions: 'Sessions de chat'
    },
    settings: {
      title: 'Paramètres',
      pageDesc: 'Gérez votre compte et vos paramètres de sécurité',
      changePassword: 'Changer le mot de passe',
      currentPassword: 'Mot de passe actuel',
      currentPasswordPh: 'Entrez le mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      newPasswordPh: 'Entrez le nouveau mot de passe (min 6 caractères)',
      confirmNewPassword: 'Confirmer le nouveau mot de passe',
      confirmNewPasswordPh: 'Ressaisissez le nouveau mot de passe',
      saving: 'Enregistrement...',
      saveChanges: 'Enregistrer',
      changeEmail: 'Changer l\'email',
      currentEmail: 'Email actuel',
      newEmail: 'Nouvel email',
      newEmailPh: 'Entrez le nouvel email',
      accountSecurity: 'Sécurité du compte',
      apiKey: 'Clé API',
      notGenerated: 'Non générée'
    },
	chatSettings: {
	  title: 'Paramètres du chat',
	  avatar: 'Avatar du chat',
	  avatarTip: 'Taille recommandée : 200x200. Formats supportés : JPG/PNG. Max 5 Mo.',
	  channelName: 'Nom du chat',
	  channelNamePlaceholder: 'Entrez le nom d\'affichage du chat',
	  welcomeMsg: 'Message de bienvenue par défaut',
	  welcomeMsgPlaceholder: 'Message de bienvenue envoyé automatiquement lorsqu\'un visiteur accède au chat',
	  save: 'Enregistrer les paramètres',
	  saving: 'Enregistrement...',
	  saveSuccess: 'Enregistré avec succès',
	  saveFailed: 'Échec de l\'enregistrement'
	},
    chatPlan: {
      title: 'Forfaits chat',
      currentPlan: 'Forfait actuel',
      perMonth: '/mois',
      seats: 'Agents',
      seatsUnit: '',
      maxSessions: 'Sessions max',
      expiryTime: 'Expiration',
      daysLeft: '({0} jours restants)',
      autoRenew: 'Renouvellement auto',
      btnRenew: 'Renouveler',
      btnUpgrade: 'Améliorer',
      plansTitle: 'Forfaits',
      recommended: 'Recommandé',
      current: 'Actuel',
      selectPlan: 'Choisir ce forfait',
      renewalTitle: 'Historique de renouvellement',
      thOrderId: 'N° commande',
      thPlan: 'Forfait',
      thAmount: 'Montant',
      thPayment: 'Paiement',
      thDuration: 'Durée',
      thExpiry: 'Expiration',
      thStatus: 'Statut',
      renewModalTitle: 'Renouveler le forfait',
      month: '{0} mois',
      discount10: '-10%',
      discount7: '-30%',
      confirmRenew: 'Confirmer le renouvellement',
      renewSuccess: 'Renouvelé ! Prolongé de {0} mois',
	  kaiqiok: 'Activé avec succès',
	  guanbiok: 'Désactivé avec succès',
      renewFailed: 'Échec du renouvellement',
      retryLater: 'Veuillez réessayer',
      switchSuccess: 'Basculé vers {0}',
      switchFailed: 'Échec du changement'
    },
    chatManage: {
      sessionList: 'Sessions',
      sessionCount: '{0} sessions',
      searchVisitor: 'Rechercher un visiteur...',
      online: 'En ligne',
      offline: 'Hors ligne',
      source: 'Source :',
      btnTransfer: 'Transférer',
      btnEndSession: 'Terminer la session',
      btnEnd: 'Terminer',
      inputPlaceholder: 'Tapez un message...',
      send: 'Envoyer',
      me: 'Moi',
      selectSession: 'Sélectionnez une session pour commencer',
      emoji: 'Emoji',
      file: 'Fichier'
    },
    receptionRecords: {
      title: 'Historique d\'accueil',
      allStatus: 'Tous les statuts',
      completed: 'Terminé',
      ongoing: 'En cours',
      missed: 'Manqué',
      searchVisitor: 'Rechercher le nom du visiteur...',
      visitor: 'Visiteur',
      source: 'Source',
      agent: 'Agent',
      startTime: 'Heure de début',
      endTime: 'Heure de fin',
      messages: 'Messages',
      satisfaction: 'Satisfaction',
      status: 'Statut',
      action: 'Action',
      view: 'Voir',
      notRated: 'Non évalué',
      totalRecords: '{0} enregistrements',
      prevPage: 'Précédent',
      nextPage: 'Suivant',
      detailTitle: 'Détail de la session',
      visitorEmail: 'Email du visiteur :',
      sourceLabel: 'Source :',
      agentLabel: 'Agent :',
      durationLabel: 'Durée :',
      minute: 'min'
    },
    agentManage: {
      title: 'Gestion des agents',
      addAgent: 'Ajouter un agent',
      agent: 'Agent',
      account: 'Compte',
      status: 'Statut',
      currentSessions: 'Actif',
      lastOnline: 'Dernière connexion',
      action: 'Action',
      online: 'En ligne',
      offline: 'Hors ligne',
      enable: 'Activer',
      disable: 'Désactiver',
      edit: 'Modifier',
      delete: 'Supprimer',
      loading: 'Chargement...',
      empty: 'Aucun agent pour le moment, cliquez sur Ajouter en haut à droite',
      addTitle: 'Ajouter un agent',
      editTitle: 'Modifier l\'agent',
      nameLabel: 'Nom de l\'agent',
      namePlaceholder: 'ex. Support Zhang',
      accountLabel: 'Compte de connexion',
      accountPlaceholder: 'ex. kefu1',
      passwordLabel: 'Mot de passe',
      passwordPlaceholder: 'Au moins 6 caractères',
      resetPasswordLabel: 'Réinitialiser le mot de passe (laisser vide pour conserver)',
      resetPasswordPlaceholder: 'Laisser vide pour conserver le mot de passe actuel',
      statusLabel: 'Statut',
      cancel: 'Annuler',
      saving: 'Enregistrement...',
      save: 'Enregistrer',
      nameRequired: 'Veuillez saisir le nom de l\'agent',
      passwordMin: 'Le mot de passe doit comporter au moins 6 caractères',
      accountRequired: 'Veuillez saisir le compte de connexion',
      saveSuccess: 'Enregistré avec succès',
      saveFailed: 'Échec de l\'enregistrement',
      opFailed: 'Échec de l\'opération',
      networkError: 'Erreur réseau, veuillez réessayer plus tard',
      deleteSuccess: 'Supprimé avec succès',
      deleteFailed: 'Échec de la suppression',
      toggleConfirm: 'Voulez-vous vraiment {0} l\'agent "{1}" ?',
      deleteConfirm: 'Voulez-vous vraiment supprimer l\'agent "{0}" ? Cette action est irréversible !'
    }
  },
  help: {
    title: 'Page d\'aide',
    subtitle: 'Trouvez ici les instructions sur l\'utilisation des services SMS-Man et les réponses aux questions les plus fréquentes',
    popularQuestions: 'Questions populaires',
    q1: 'Combien de temps attendre pour le SMS après l\'inscription ?',
    q1a: 'Le temps d\'attente ne dépasse pas 5 minutes. Si vous ne recevez pas le SMS dans les 5 minutes, annulez votre numéro et achetez-en un autre.',
    q2: 'Combien de SMS puis-je recevoir ?',
    q3: 'Quel est le montant minimum de recharge ?',
    q4: 'Si le service dont j\'ai besoin n\'est pas dans la liste, puis-je recevoir des SMS ?',
    q5: 'SMS non reçu, que dois-je faire ?',
    q6: 'Que signifie l\'erreur "Service temporairement indisponible" ?',
    q7: 'Où trouver ma clé API ?',
    q8: 'Comment gagner de l\'argent avec nous ?',
    serviceGuide: 'Guide du service',
    serviceGuideTitle: 'Comment m\'inscrire en ligne ?',
    serviceGuideDesc: 'Inscrivez-vous, entrez votre numéro, sélectionnez le pays, choisissez le service, cliquez sur acheter, puis attendez le SMS.',
    howToRent: 'Comment louer pour mon service ?',
    howToRentDesc: 'Sélectionnez le service, le pays, la durée, cliquez sur louer.',
    howToBuy: 'Comment acheter un SMS ponctuel ?',
    howToBuyDesc: 'Sélectionnez le service, le pays, cliquez sur acheter SMS.',
    howToUseNumber: 'Comment utiliser mon numéro loué ?',
    howToUseNumberDesc: 'Copiez le numéro, entrez-le sur le site cible, attendez le SMS.',
    footer: {
      smsPlatform: 'Plateforme SMS',
      rentNumber: 'Louer un numéro',
      apiConnection: 'API',
      referral: 'Parrainage',
      partnership: 'Partenariat',
      partners: 'Partenaires',
      blog: 'Partage',
      help: 'Aide',
      privacyPolicy: 'Politique de confidentialité',
      termsOfUse: 'Conditions d\'utilisation',
      paymentRefund: 'Paiement et remboursement',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  blog: {
    title: 'Centre d\'articles',
    recentPosts: 'Articles récents',
    archives: 'Archives',
    readMore: 'Lire la suite',
    comments: 'Vues',
    category: 'Catégorie',
    currentCategory: 'Catégorie actuelle :',
    clearFilter: '✕ Effacer le filtre',
    allCategories: 'Toutes les catégories',
    articleCategories: 'Catégories'
  },
  articleDetail: {
    loading: 'Chargement...',
    notFound: 'Article non trouvé',
    backToList: '← Retour aux articles',
    home: 'Accueil',
    blog: 'Partage',
    views: 'vues',
    share: 'Partager :',
    relatedArticles: 'Articles connexes'
  },
  homeApi: {
    title: 'Pour les développeurs',
    subtitle: 'Documentation API pour connecter vos services avec SMS-Man.',
    legacyApi: 'API héritée',
    apiV2: 'API 2.0',
    miniApi: 'Mini API',
    apiDesc: 'L\'interface API permet d\'acheter et de recevoir automatiquement des SMS.',
    getBalance: 'Obtenir le solde',
    getBalanceDesc: 'Obtenir le solde actuel',
    params: 'Paramètres',
    field: 'Champ',
    type: 'Type',
    required: 'Requis',
    value: 'Valeur',
    result: 'Résultat',
    possibleErrors: 'Erreurs possibles',
    rateLimit: 'Limite de débit',
    getNumber: 'Obtenir un numéro',
    getNumberDesc: 'Obtenir un numéro pour le pays spécifié',
    getSms: 'Obtenir SMS',
    getSmsDesc: 'Obtenir le SMS pour la commande',
    setStatus: 'Définir le statut',
    setStatusDesc: 'Changer le statut de la commande',
    getCountries: 'Obtenir la liste des pays',
    getCountriesDesc: 'Obtenir tous les pays disponibles',
    getServices: 'Obtenir la liste des services',
    getServicesDesc: 'Obtenir tous les services disponibles'
  },
  onlineSms: {
    hero: {
      title: 'Plateforme de vérification SMS en ligne',
      desc: 'Inscrivez-vous sans spam ni exposition de données personnelles.',
      viewNumbers: 'Voir les numéros',
      receiveCode: 'Recevoir le code'
    },
    countries: {
      title: 'Choisir le pays/région',
      subtitle: 'Choisissez parmi plus de 200 pays',
      services: 'services',
      select: 'Sélectionner'
    },
    services: {
      title: 'Services les plus populaires',
      buy: 'Acheter'
    },
    howItWorks: {
      title: 'Louez un numéro en 3 étapes',
      subtitle: 'Voir comment ça marche',
      step1Title: 'Choisir le pays',
      step1Desc: 'Sélectionnez le pays parmi plus de 200 options',
      step2Title: 'Choisir le service',
      step2Desc: 'Sélectionnez l\'application ou le service',
      step3Title: 'Recevoir SMS',
      step3Desc: 'Obtenez un numéro et recevez les codes'
    },
    features: {
      fastTitle: 'Vérification rapide',
      fastDesc: 'Obtenez les codes en quelques secondes',
      safeTitle: 'Protection de la vie privée',
      safeDesc: 'Utilisez des numéros virtuels',
      globalTitle: 'Couverture mondiale',
      globalDesc: 'Services dans plus de 200 pays'
    },
    cta: {
      title: 'Inscrivez-vous maintenant',
      desc: 'Obtenez des crédits gratuits',
      register: 'Inscription gratuite'
    },
    faq: {
      title: 'FAQ',
      q1: 'Qu\'est-ce que la vérification SMS en ligne ?',
      a1: 'C\'est un service utilisant des numéros virtuels.',
      q2: 'Combien de temps puis-je utiliser un numéro ?',
      a2: 'De 20 minutes à 30 jours selon le service.',
      q3: 'Comment la confidentialité est-elle protégée ?',
      a3: 'Tous les numéros sont virtuels et détruits après utilisation.'
    }
  },
  esim: {
    hero: {
      title: 'Acheter eSIM en ligne',
      desc: 'Obtenez des données mobiles instantanément.',
      learnMore: 'En savoir plus',
      countries: 'Pays',
      network: 'Réseau',
      activation: 'Activation'
    },
    howItWorks: {
      title: 'Connecté en 3 étapes',
      step1Title: 'Choisir votre forfait',
      step1Desc: 'Sélectionnez le pays et le forfait',
      step2Title: 'Payer et obtenir le QR',
      step2Desc: 'Vous recevrez un code QR',
      step3Title: 'Scanner et se connecter',
      step3Desc: 'Scannez le QR code'
    },
    whyEsim: {
      title: 'Pourquoi eSIM',
      subtitle: 'Une manière plus intelligente',
      f1Title: 'Pas de frais d\'itinérance',
      f1Desc: 'Utilisez les réseaux locaux',
      f2Title: 'Activation instantanée',
      f2Desc: 'Activez en scannant le QR',
      f3Title: 'Gardez votre carte principale',
      f3Desc: 'Continuez à utiliser votre numéro'
    },
    cta: {
      title: 'Prêt à voyager sans frais ?',
      desc: 'Activez votre eSIM en minutes'
    },
    comparison: {
      title: 'eSIM vs carte SIM locale',
      r1: 'Configuration avant le voyage',
      r2: 'Activation instantanée',
      r3: 'Pas de changement de carte',
      r4: 'Gardez votre numéro',
      r5: 'Prix fixe',
      r6: 'Inscription par email',
      r7: 'Crypto accepté'
    },
    plus: {
      title: 'eSIM, plus tout ce que SMS-MAN fait',
      desc: 'Associez votre forfait avec des numéros virtuels'
    },
    faq: {
      title: 'Questions sur l\'eSIM',
      q1: 'Qu\'est-ce qu\'une eSIM ?',
      a1: 'Une carte SIM intégrée qui active les données mobiles.',
      q2: 'Quels appareils prennent en charge l\'eSIM ?',
      a2: 'La plupart des smartphones modernes.',
      q3: 'Quelle est la vitesse d\'activation ?',
      a3: 'Généralement quelques secondes.',
      q4: 'Mon eSIM remplacera-t-elle mon numéro ?',
      a4: 'Non, l\'eSIM est pour les données.',
      q5: 'Puis-je recharger ?',
      a5: 'Oui, vous pouvez acheter des forfaits supplémentaires.'
    }
  },
  agent: {
    hero: {
      title: 'Devenez agent SMS-MAN',
      desc: 'Gagnez des commissions en promouvant SMS-MAN.',
      becomeAgent: 'Devenir agent',
      learnMore: 'En savoir plus'
    },
    benefits: {
      title: 'Avantages des agents',
      subtitle: 'Pourquoi devenir agent',
      b1Title: 'Commission élevée',
      b1Desc: 'Jusqu\'à 20% de commission',
      b2Title: 'Revenu passif',
      b2Desc: 'Gagnez tant que vos références dépensent',
      b3Title: 'Support dédié',
      b3Desc: 'Gestionnaire de compte exclusif',
      b4Title: 'Marché mondial',
      b4Desc: 'Promouvez sans restrictions'
    },
    howItWorks: {
      title: 'Comment commencer',
      step1Title: 'Créer un compte',
      step1Desc: 'Inscrivez-vous et postulez',
      step2Title: 'Obtenir un lien',
      step2Desc: 'Recevez votre lien de parrainage',
      step3Title: 'Gagner',
      step3Desc: 'Gagnez quand les utilisateurs dépensent'
    },
    commission: {
      title: 'Niveaux de commission',
      l1Name: 'Agent junior',
      l1Desc: '1-50 utilisateurs par mois',
      l2Name: 'Agent intermédiaire',
      l2Desc: '51-200 utilisateurs par mois',
      l3Name: 'Agent senior',
      l3Desc: '200+ utilisateurs par mois'
    },
    features: {
      title: 'Outils des agents',
      f1Title: 'Tableau de bord',
      f1Desc: 'Vue en temps réel des données',
      f2Title: 'Lien de parrainage',
      f2Desc: 'Lien unique avec suivi précis',
      f3Title: 'Retrait rapide',
      f3Desc: 'Retirez à tout moment',
      f4Title: 'Support dédié',
      f4Desc: 'Canal de support exclusif'
    },
    cta: {
      title: 'Prêt à commencer ?',
      desc: 'Inscrivez-vous maintenant',
      joinNow: 'Rejoindre maintenant'
    }
  },
  softwareDev: {
    heroTitle: 'Services de développement logiciel',
    heroDesc: 'De l\'analyse des besoins à la livraison.',
    btnViewCases: 'Voir les cas',
    btnContact: 'Nous contacter',
    servicesTitle: 'Services',
    servicesSubtitle: 'Services complets de développement',
    service1Title: 'Développement web',
    service1Desc: 'Sites, e-commerce, SaaS',
    service2Title: 'Applications mobiles',
    service2Desc: 'iOS/Android natif et multiplateforme',
    service3Title: 'Développement API',
    service3Desc: 'API RESTful, WebSocket',
    service4Title: 'Systèmes d\'automatisation',
    service4Desc: 'Collecte de données, scripts',
    service5Title: 'Systèmes de jeu',
    service5Desc: 'Jeux de cartes, loteries',
    service6Title: 'Déploiement cloud',
    service6Desc: 'Serveurs, CI/CD, Docker',
    techStackTitle: 'Stack technique',
    casesTitle: 'Cas de projets',
    casesSubtitle: 'Projets livrés',
    projectShare: 'Partage',
    processTitle: 'Processus de développement',
    process1Title: 'Discussion des besoins',
    process1Desc: 'Compréhension approfondie',
    process2Title: 'Conception',
    process2Desc: 'Architecture technique',
    process3Title: 'Développement',
    process3Desc: 'Développement agile',
    process4Title: 'Tests',
    process4Desc: 'Tests complets',
    process5Title: 'Déploiement',
    process5Desc: 'Mise en production',
    process6Title: 'Maintenance',
    process6Desc: 'Support continu',
    stats1Label: 'Projets livrés',
    stats2Label: 'Clients satisfaits',
    stats3Label: 'Années d\'expérience',
    stats4Label: 'Satisfaction',
    contactTitle: 'Un projet en tête ?',
    contactDesc: 'Parlez-nous de vos idées',
    contactOnline: 'Support en ligne',
    contactBtn: 'Consulter'
  },
  lotteryPage: {
    heroTitle: 'Centre de loterie en direct',
    heroDesc: 'Tirages instantanés, données en temps réel',
    statLottery: 'Types de loterie',
    statNonStop: 'Tirages continus',
    statSync: 'Sync temps réel',
    periodDraw: 'Tirage #{0}',
    currentRemain: 'Actuel {0}, Restant {1}',
    dragonTiger: '1-5 Dragon/Tigre',
    championSum: 'Somme du champion',
    betNow: 'Parier',
    tabHistory: 'Historique',
    tabRoad: 'Analyse',
    tabHotCold: 'Chaud/Froid',
    tabTrend: 'Tendance',
    rulesTitle: 'Règles',
    rule1Title: 'Dragon/Tigre',
    rule1Desc: 'Comparez les numéros.',
    rule2Title: 'Somme du champion',
    rule2Desc: 'Additionnez les numéros.',
    rule3Title: 'Grand/Petit',
    rule3Desc: 'Déterminez grand ou petit.',
    rule4Title: 'Analyse de route',
    rule4Desc: 'Analysez les tendances.',
    dragon: 'Dragon',
    tiger: 'Tigre',
    big: 'Grand',
    small: 'Petit',
    odd: 'Impair',
    even: 'Pair',
    countdownMin: 'min',
    countdownSec: 'sec',
    nameSpeedRacing: 'Course rapide',
    nameSgAirship: 'Dirigeable SG',
    nameSpeedAirship: 'Dirigeable rapide',
    nameLuckyAirship: 'Dirigeable chanceux',
    logoRacing: 'Course',
    logoAirship: 'Dirigeable'
  },
  apiDocs: {
    pageTitle: 'Documentation API',
    pageSubtitle: 'Interfaces API pour intégration rapide',
    tabSms: 'API SMS',
    tabLottery: 'API Loterie',
    tabChat: 'API Chat',
    versionLegacy: 'API héritée',
    versionV2: 'API 2.0',
    versionMini: 'Mini API',
    baseAddress: 'URL de base',
    requestMethod: 'Méthode',
    returnFormat: 'Format de réponse',
    authMethod: 'Authentification',
    requestParams: 'Paramètres',
    field: 'Champ',
    type: 'Type',
    required: 'Requis',
    description: 'Description',
    yes: 'Oui',
    no: 'Non',
    returnExample: 'Exemple de réponse',
    smsDesc: 'API SMS complète pour 200+ pays.',
    lotteryDesc: 'API loterie avec données en temps réel.',
    chatDesc: 'API chat avec WebSocket.',
    ep: {
      getBalance: 'Obtenir solde', getNumber: 'Obtenir numéro', getSms: 'Obtenir SMS',
      checkBalance: 'Vérifier solde', createOrder: 'Créer commande', querySms: 'Interroger SMS',
      setStatus: 'Définir statut', getCountries: 'Obtenir pays', getServices: 'Obtenir services',
      getLotteryList: 'Liste loteries', getLotteryHistory: 'Historique loteries',
      getLotteryTypes: 'Types loterie', liveDraw: 'Tirage en direct',
      lotteryHistory: 'Historique tirages', lotteryStats: 'Statistiques tirages',
      latestDraw: 'Dernier tirage', createSession: 'Créer session',
      sendMessage: 'Envoyer message', getMessageHistory: 'Historique messages',
      agentStatus: 'Statut agent', closeSession: 'Fermer session', quickSend: 'Envoi rapide'
    },
    epd: {
      getBalance: 'Solde actuel', getNumber: 'Numéro virtuel pour SMS',
      getSms: 'Code SMS pour un numéro', checkBalance: 'Solde disponible',
      createOrder: 'Créer commande SMS', querySms: 'Obtenir contenu SMS',
      setStatus: 'Définir statut (reçu/annuler/continuer)',
      getCountries: 'Tous les pays supportés', getServices: 'Tous les services SMS',
      getLotteryList: 'Infos tirages récents', getLotteryHistory: 'Historique d\'un type',
      getLotteryTypes: 'Tous les types supportés', liveDraw: 'Dernier résultat',
      lotteryHistory: 'Historique paginé', lotteryStats: 'Statistiques (chaud/froid)',
      latestDraw: 'Derniers tirages (simplifié)', createSession: 'Nouvelle session',
      sendMessage: 'Envoyer à une session', getMessageHistory: 'Historique d\'une session',
      agentStatus: 'Liste agents en ligne', closeSession: 'Fermer une session',
      quickSend: 'Créer et envoyer en un appel',
      getNumberSimple: 'Obtenir numéro en un clic', getSmsSimple: 'Obtenir contenu SMS',
      createSessionV2: 'Créer avec attribution auto', sendMessageV2: 'Envoyer à une session'
    }
  },
  liveChat: {
    heroTitle: 'Système de chat en direct',
    heroDesc: 'Plateforme de chat en temps réel avec WebSocket.',
    btnFreeTrial: 'Essai gratuit',
	catedengl: 'Connexion au service client',
    btnDemo: 'Télécharger le client de bureau',
    previewName: 'Agent Wang',
    previewStatus: '● En ligne',
    previewMsg1: 'Bonjour ! Comment puis-je vous aider ?',
    previewMsg2: 'Je voudrais connaître vos services',
    previewMsg3: 'Bien sûr, laissez-moi vous présenter...',
    inputPlaceholder: 'Tapez un message...',
    featuresTitle: 'Fonctionnalités principales',
    featuresSubtitle: 'Solution complète pour améliorer la satisfaction',
    feature1Title: 'Messagerie en temps réel',
    feature1Desc: 'Delivery milliseconde via WebSocket',
    feature2Title: 'Collaboration multi-agents',
    feature2Desc: 'Plusieurs agents en ligne simultanément',
    feature3Title: 'Historique des messages',
    feature3Desc: 'Historique complet avec recherche',
    feature4Title: 'Transfert de fichiers',
    feature4Desc: 'Envoyez et recevez des images et documents',
    feature5Title: 'Routage intelligent',
    feature5Desc: 'Attribution auto selon la charge',
    feature6Title: 'Analyses et rapports',
    feature6Desc: 'Statistiques en temps réel',
    stepsTitle: 'Configuration rapide',
    step1Title: 'Créer un compte',
    step1Desc: 'Configurez votre équipe',
    step2Title: 'Intégrer le code',
    step2Desc: 'Intégrez sur votre site',
    step3Title: 'Démarrer le service',
    step3Desc: 'Les agents se connectent',
    dashboardTitle: 'Panneau d\'administration',
    dashboardDesc: 'Surveillez en temps réel',
    dashFeature1: 'Statut des agents en temps réel',
    dashFeature2: 'Règles de routage',
    dashFeature3: 'Horaires et performances',
    dashFeature4: 'Évaluations clients',
    dashFeature5: 'Recherche d\'historique',
    dashFeature6: 'Réponses rapides personnalisées',
    dashStat1: 'Sessions aujourd\'hui',
    dashStat2: 'Satisfaction',
    dashStat3: 'Temps de réponse',
    dashStat4: 'Agents en ligne',
    pricingTitle: 'Forfaits',
    pricingBadge: 'Recommandé',
    pricingPeriod: '/mois',
    btnSelectPlan: 'Choisir',
    planBasic: 'Basique',
    planPro: 'Professionnel',
    planEnterprise: 'Entreprise',
    ctaTitle: 'Prêt à améliorer votre service ?',
    ctaDesc: 'Inscrivez-vous et essayez gratuitement',
    ctaBtn: 'Commencer gratuitement',
    pf1Basic: '1 Agents', pf2Realtime: 'Chat en temps réel', pf3History: 'Historique',
    pf4Reports: 'Rapports de base', pf5Email: 'Support email',
    pf1Agents: '10 Agents', pf4AdvReports: 'Rapports avancés', pf5Smart: 'Routage intelligent',
    pf6File: 'Transfert fichiers', pf7Priority: 'Support prioritaire',
    ef1Unlimited: 'Agents illimités', ef2All: 'Toutes les fonctionnalités', ef3Api: 'Accès API',
    ef4Private: 'Déploiement privé', ef5Dedicated: 'Support dédié', ef6Sla: 'Garantie SLA'
  },
  apiMsg: {
    userNotFound: 'Cet email n’est pas inscrit', wrongPassword: 'Mot de passe incorrect', accountDisabled: 'Ce compte a été désactivé',
    agentNotFound: 'Le compte agent n’existe pas', agentDisabled: 'Ce compte agent a été désactivé',
    notLogin: 'Veuillez d’abord vous connecter', tokenExpired: 'Session expirée, veuillez vous reconnecter',
    emailRequired: 'Saisissez votre email', emailInvalid: 'Format d’email invalide',
    emailPasswordRequired: 'Email et mot de passe obligatoires', accountPasswordRequired: 'Compte et mot de passe obligatoires',
    agentAccountRequired: 'Compte agent et mot de passe obligatoires',
    passwordMin: 'Le mot de passe doit contenir au moins 6 caractères', newPasswordMin: 'Le nouveau mot de passe doit contenir au moins 6 caractères',
    emailExists: 'Cet email est déjà utilisé', usernameExists: 'Ce nom d’utilisateur est déjà pris',
    captchaWrong: 'Code de vérification incorrect', captchaExpired: 'Code expiré, veuillez en demander un nouveau',
    paramError: 'Paramètres invalides', paramIncomplete: 'Veuillez remplir tous les champs', missingId: 'Identifiant manquant',
    nothingToUpdate: 'Rien à mettre à jour', invalidStatus: 'Valeur de statut invalide', indexOutOfRange: 'Index hors plage',
    missingChannelCode: 'Code de canal manquant', channelNotFound: 'Canal introuvable', channelClosed: 'Ce canal est fermé',
    noChatChannel: 'Ce membre n’a pas activé de canal de support', chatPlanExpired: 'Le forfait support a expiré et est indisponible',
    noAgentOnlineRetry: 'Aucun agent en ligne pour le moment, réessayez plus tard',
    targetAgentInvalid: 'L’agent cible n’existe pas ou est désactivé', agentNoOperate: 'Agent inexistant ou opération non autorisée',
    sessionNotFound: 'Conversation introuvable', sessionMismatch: 'Conversation non concordante',
    noPermissionTransfer: 'Vous ne pouvez pas transférer cette conversation', noPermissionClose: 'Vous ne pouvez pas clôturer cette conversation',
    noPermissionDelete: 'Vous ne pouvez pas supprimer cette conversation',
    chatHasHistory: 'Cette conversation contient des messages et ne peut être supprimée', clientOnline: 'Le client est en ligne, suppression impossible',
    onlyAgentRecall: 'Seuls les messages des agents peuvent être retirés',
    balanceInsufficient: 'Solde insuffisant', rechargeMinAmount: 'Le montant minimum de recharge est de 1 USD',
    orderNotFound: 'Commande introuvable', orderCancelled: 'Cette commande est déjà annulée', orderConfirmed: 'Ce paiement est déjà confirmé',
    orderNotPayable: 'Le statut de la commande ne permet pas cette opération',
    planNotFound: 'Forfait introuvable', serviceNotFound: 'Service introuvable', articleNotFound: 'Article introuvable',
    numberUnavailable: 'Ce numéro n’est pas disponible', noAvailableNumber: 'Aucun numéro disponible',
    numberExists: 'Ce numéro existe déjà', rentalNotFound: 'Enregistrement de location introuvable',
    agentLimitReached: 'La limite d’agents de votre forfait est atteinte', emailSendFailed: 'Échec d’envoi de l’email, réessayez plus tard'
  },
  clientDownload: {
    badge: 'Client de bureau officiel',
    heroTitle: 'Télécharger le client de service client',
    heroDesc: 'Un client de bureau conçu pour les agents : gestion de plusieurs conversations, messages en temps réel, réponses rapides et transfert entre agents pour servir chaque client efficacement.',
    winDownload: 'Télécharger pour Windows',
    winHint: 'Windows 10 / 11',
    macDownload: 'Télécharger pour macOS',
    macHint: 'macOS 10.15 ou ultérieur',
    previewAlt: 'Aperçu du client de service client',
    notice: 'Décompressez et lancez l’application, aucune installation n’est nécessaire. Si le système signale un développeur non identifié, autorisez son exécution dans les réglages.',
    featuresTitle: 'Fonctionnalités clés',
    featuresSubtitle: 'Un outil de bureau pensé pour un fort volume de conversations, plus stable et plus rapide que la version web',
    f1Title: 'Gestion multi-conversations',
    f1Desc: 'La liste des conversations à gauche se met à jour en temps réel et les messages non lus sont mis en évidence : aucun client n’est oublié.',
    f2Title: 'Messages en temps réel',
    f2Desc: 'Grâce à une connexion WebSocket permanente, les messages des visiteurs arrivent en quelques millisecondes, avec reconnexion automatique.',
    f3Title: 'Réponses rapides',
    f3Desc: 'Envoyez vos réponses types en un clic pour réduire la saisie et accélérer nettement vos réponses.',
    f4Title: 'Transfert et collaboration',
    f4Desc: 'Transférez une conversation à un autre agent pour traiter les cas complexes en équipe.',
    stepsTitle: 'Démarrez en trois étapes',
    s1Title: 'Télécharger et décompresser',
    s1Desc: 'Choisissez la version Windows ou macOS, puis lancez l’application après décompression.',
    s2Title: 'Connectez-vous avec votre compte agent',
    s2Desc: 'Utilisez le compte créé dans l’espace membre : les conversations de votre canal sont synchronisées automatiquement.',
    s3Title: 'Accueillez vos clients',
    s3Desc: 'Les messages arrivent en temps réel ; réponses rapides et transferts rendent le service plus efficace.',
    ctaTitle: 'Pas encore de compte agent ?',
    ctaDesc: 'Créez un compte agent dans l’espace membre et commencez immédiatement.',
    ctaBtn: 'Aller à l’espace membre'
  },
  visitorChat: {
    noAgentOnline: 'Aucun agent en ligne pour le moment. Vos messages seront pris en compte dès qu\'un agent sera en ligne.',
    online: 'En ligne',
    offline: 'Hors ligne',
    connecting: 'Connexion...',
    defaultTitle: 'Service client en ligne',
    defaultWelcome: 'Bonjour ! Bienvenue dans le service client en ligne. Comment pouvons-nous vous aider ?',
    channelNotFound: 'Le canal n\'existe pas ou est fermé',
    loadError: 'Échec du chargement, veuillez réessayer plus tard',
    imageTooLarge: 'La taille de l\'image ne peut pas dépasser 2 Mo',
    sendImage: 'Envoyer une image',
    inputPlaceholder: 'Tapez un message...',
    supportSuffix: ' - Service client'
  }
}
